const aryIanaTimeZones = [
	'Europe/Andorra',
	'Asia/Dubai',
	'Asia/Kabul',
	'Europe/Tirane',
	'Asia/Yerevan',
	'Antarctica/Casey',
	'Antarctica/Davis',
	'Antarctica/DumontDUrville',
	'Antarctica/Mawson',
	'Antarctica/Palmer',
	'Antarctica/Rothera',
	'Antarctica/Syowa',
	'Antarctica/Troll',
	'Antarctica/Vostok',
	'America/Argentina/Buenos_Aires',
	'America/Argentina/Cordoba',
	'America/Argentina/Salta',
	'America/Argentina/Jujuy',
	'America/Argentina/Tucuman',
	'America/Argentina/Catamarca',
	'America/Argentina/La_Rioja',
	'America/Argentina/San_Juan',
	'America/Argentina/Mendoza',
	'America/Argentina/San_Luis',
	'America/Argentina/Rio_Gallegos',
	'America/Argentina/Ushuaia',
	'Pacific/Pago_Pago',
	'Europe/Vienna',
	'Australia/Lord_Howe',
	'Antarctica/Macquarie',
	'Australia/Hobart',
	'Australia/Currie',
	'Australia/Melbourne',
	'Australia/Sydney',
	'Australia/Broken_Hill',
	'Australia/Brisbane',
	'Australia/Lindeman',
	'Australia/Adelaide',
	'Australia/Darwin',
	'Australia/Perth',
	'Australia/Eucla',
	'Asia/Baku',
	'America/Barbados',
	'Asia/Dhaka',
	'Europe/Brussels',
	'Europe/Sofia',
	'Atlantic/Bermuda',
	'Asia/Brunei',
	'America/La_Paz',
	'America/Noronha',
	'America/Belem',
	'America/Fortaleza',
	'America/Recife',
	'America/Araguaina',
	'America/Maceio',
	'America/Bahia',
	'America/Sao_Paulo',
	'America/Campo_Grande',
	'America/Cuiaba',
	'America/Santarem',
	'America/Porto_Velho',
	'America/Boa_Vista',
	'America/Manaus',
	'America/Eirunepe',
	'America/Rio_Branco',
	'America/Nassau',
	'Asia/Thimphu',
	'Europe/Minsk',
	'America/Belize',
	'America/St_Johns',
	'America/Halifax',
	'America/Glace_Bay',
	'America/Moncton',
	'America/Goose_Bay',
	'America/Blanc-Sablon',
	'America/Toronto',
	'America/Nipigon',
	'America/Thunder_Bay',
	'America/Iqaluit',
	'America/Pangnirtung',
	'America/Atikokan',
	'America/Winnipeg',
	'America/Rainy_River',
	'America/Resolute',
	'America/Rankin_Inlet',
	'America/Regina',
	'America/Swift_Current',
	'America/Edmonton',
	'America/Cambridge_Bay',
	'America/Yellowknife',
	'America/Inuvik',
	'America/Creston',
	'America/Dawson_Creek',
	'America/Fort_Nelson',
	'America/Vancouver',
	'America/Whitehorse',
	'America/Dawson',
	'Indian/Cocos',
	'Europe/Zurich',
	'Africa/Abidjan',
	'Pacific/Rarotonga',
	'America/Santiago',
	'America/Punta_Arenas',
	'Pacific/Easter',
	'Asia/Shanghai',
	'Asia/Urumqi',
	'America/Bogota',
	'America/Costa_Rica',
	'America/Havana',
	'Atlantic/Cape_Verde',
	'America/Curacao',
	'Indian/Christmas',
	'Asia/Nicosia',
	'Asia/Famagusta',
	'Europe/Prague',
	'Europe/Berlin',
	'Europe/Copenhagen',
	'America/Santo_Domingo',
	'Africa/Algiers',
	'America/Guayaquil',
	'Pacific/Galapagos',
	'Europe/Tallinn',
	'Africa/Cairo',
	'Africa/El_Aaiun',
	'Europe/Madrid',
	'Africa/Ceuta',
	'Atlantic/Canary',
	'Europe/Helsinki',
	'Pacific/Fiji',
	'Atlantic/Stanley',
	'Pacific/Chuuk',
	'Pacific/Pohnpei',
	'Pacific/Kosrae',
	'Atlantic/Faroe',
	'Europe/Paris',
	'Europe/London',
	'Asia/Tbilisi',
	'America/Cayenne',
	'Africa/Accra',
	'Europe/Gibraltar',
	'America/Godthab',
	'America/Danmarkshavn',
	'America/Scoresbysund',
	'America/Thule',
	'Europe/Athens',
	'Atlantic/South_Georgia',
	'America/Guatemala',
	'Pacific/Guam',
	'Africa/Bissau',
	'America/Guyana',
	'Asia/Hong_Kong',
	'America/Tegucigalpa',
	'America/Port-au-Prince',
	'Europe/Budapest',
	'Asia/Jakarta',
	'Asia/Pontianak',
	'Asia/Makassar',
	'Asia/Jayapura',
	'Europe/Dublin',
	'Asia/Jerusalem',
	'Asia/Kolkata',
	'Indian/Chagos',
	'Asia/Baghdad',
	'Asia/Tehran',
	'Atlantic/Reykjavik',
	'Europe/Rome',
	'America/Jamaica',
	'Asia/Amman',
	'Asia/Tokyo',
	'Africa/Nairobi',
	'Asia/Bishkek',
	'Pacific/Tarawa',
	'Pacific/Enderbury',
	'Pacific/Kiritimati',
	'Asia/Pyongyang',
	'Asia/Seoul',
	'Asia/Almaty',
	'Asia/Qyzylorda',
	'Asia/Qostanay',
	'Asia/Aqtobe',
	'Asia/Aqtau',
	'Asia/Atyrau',
	'Asia/Oral',
	'Asia/Beirut',
	'Asia/Colombo',
	'Africa/Monrovia',
	'Europe/Vilnius',
	'Europe/Luxembourg',
	'Europe/Riga',
	'Africa/Tripoli',
	'Africa/Casablanca',
	'Europe/Monaco',
	'Europe/Chisinau',
	'Pacific/Majuro',
	'Pacific/Kwajalein',
	'Asia/Yangon',
	'Asia/Ulaanbaatar',
	'Asia/Hovd',
	'Asia/Choibalsan',
	'Asia/Macau',
	'America/Martinique',
	'Europe/Malta',
	'Indian/Mauritius',
	'Indian/Maldives',
	'America/Mexico_City',
	'America/Cancun',
	'America/Merida',
	'America/Monterrey',
	'America/Matamoros',
	'America/Mazatlan',
	'America/Chihuahua',
	'America/Ojinaga',
	'America/Hermosillo',
	'America/Tijuana',
	'America/Bahia_Banderas',
	'Asia/Kuala_Lumpur',
	'Asia/Kuching',
	'Africa/Maputo',
	'Africa/Windhoek',
	'Pacific/Noumea',
	'Pacific/Norfolk',
	'Africa/Lagos',
	'America/Managua',
	'Europe/Amsterdam',
	'Europe/Oslo',
	'Asia/Kathmandu',
	'Pacific/Nauru',
	'Pacific/Niue',
	'Pacific/Auckland',
	'Pacific/Chatham',
	'America/Panama',
	'America/Lima',
	'Pacific/Tahiti',
	'Pacific/Marquesas',
	'Pacific/Gambier',
	'Pacific/Port_Moresby',
	'Pacific/Bougainville',
	'Asia/Manila',
	'Asia/Karachi',
	'Europe/Warsaw',
	'America/Miquelon',
	'Pacific/Pitcairn',
	'America/Puerto_Rico',
	'Asia/Gaza',
	'Asia/Hebron',
	'Europe/Lisbon',
	'Atlantic/Madeira',
	'Atlantic/Azores',
	'Pacific/Palau',
	'America/Asuncion',
	'Asia/Qatar',
	'Indian/Reunion',
	'Europe/Bucharest',
	'Europe/Belgrade',
	'Europe/Kaliningrad',
	'Europe/Moscow',
	'Europe/Simferopol',
	'Europe/Kirov',
	'Europe/Astrakhan',
	'Europe/Volgograd',
	'Europe/Saratov',
	'Europe/Ulyanovsk',
	'Europe/Samara',
	'Asia/Yekaterinburg',
	'Asia/Omsk',
	'Asia/Novosibirsk',
	'Asia/Barnaul',
	'Asia/Tomsk',
	'Asia/Novokuznetsk',
	'Asia/Krasnoyarsk',
	'Asia/Irkutsk',
	'Asia/Chita',
	'Asia/Yakutsk',
	'Asia/Khandyga',
	'Asia/Vladivostok',
	'Asia/Ust-Nera',
	'Asia/Magadan',
	'Asia/Sakhalin',
	'Asia/Srednekolymsk',
	'Asia/Kamchatka',
	'Asia/Anadyr',
	'Asia/Riyadh',
	'Pacific/Guadalcanal',
	'Indian/Mahe',
	'Africa/Khartoum',
	'Europe/Stockholm',
	'Asia/Singapore',
	'America/Paramaribo',
	'Africa/Juba',
	'Africa/Sao_Tome',
	'America/El_Salvador',
	'Asia/Damascus',
	'America/Grand_Turk',
	'Africa/Ndjamena',
	'Indian/Kerguelen',
	'Asia/Bangkok',
	'Asia/Dushanbe',
	'Pacific/Fakaofo',
	'Asia/Dili',
	'Asia/Ashgabat',
	'Africa/Tunis',
	'Pacific/Tongatapu',
	'Europe/Istanbul',
	'America/Port_of_Spain',
	'Pacific/Funafuti',
	'Asia/Taipei',
	'Europe/Kiev',
	'Europe/Uzhgorod',
	'Europe/Zaporozhye',
	'Pacific/Wake',
	'America/New_York',
	'America/Detroit',
	'America/Kentucky/Louisville',
	'America/Kentucky/Monticello',
	'America/Indiana/Indianapolis',
	'America/Indiana/Vincennes',
	'America/Indiana/Winamac',
	'America/Indiana/Marengo',
	'America/Indiana/Petersburg',
	'America/Indiana/Vevay',
	'America/Chicago',
	'America/Indiana/Tell_City',
	'America/Indiana/Knox',
	'America/Menominee',
	'America/North_Dakota/Center',
	'America/North_Dakota/New_Salem',
	'America/North_Dakota/Beulah',
	'America/Denver',
	'America/Boise',
	'America/Phoenix',
	'America/Los_Angeles',
	'America/Anchorage',
	'America/Juneau',
	'America/Sitka',
	'America/Metlakatla',
	'America/Yakutat',
	'America/Nome',
	'America/Adak',
	'Pacific/Honolulu',
	'America/Montevideo',
	'Asia/Samarkand',
	'Asia/Tashkent',
	'America/Caracas',
	'Asia/Ho_Chi_Minh',
	'Pacific/Efate',
	'Pacific/Wallis',
	'Pacific/Apia',
	'Africa/Johannesburg'
];
const TimeZones = [
	'Europe/Andorra (UTC+2)',
'Asia/Dubai (UTC+4)',
'Asia/Kabul (UTC+4:30)',
'Europe/Tirane (UTC+2)',
'Asia/Yerevan (UTC+4)',
'Antarctica/Casey (UTC+8)',
'Antarctica/Davis (UTC+7)',
'Antarctica/DumontDUrville (UTC+10)',
'Antarctica/Mawson (UTC+5)',
'Antarctica/Palmer (UTC-3)',
'Antarctica/Rothera (UTC-3)',
'Antarctica/Syowa (UTC+3)',
'Antarctica/Troll (UTC+0)',
'Antarctica/Vostok (UTC+6)',
'America/Argentina/Buenos_Aires (UTC-3)',
'America/Argentina/Cordoba (UTC-3)',
'America/Argentina/Salta (UTC-3)',
'America/Argentina/Jujuy (UTC-3)',
'America/Argentina/Tucuman (UTC-3)',
'America/Argentina/Catamarca (UTC-3)',
'America/Argentina/La_Rioja (UTC-3)',
'America/Argentina/San_Juan (UTC-3)',
'America/Argentina/Mendoza (UTC-3)',
'America/Argentina/San_Luis (UTC-3)',
'America/Argentina/Rio_Gallegos (UTC-3)',
'America/Argentina/Ushuaia (UTC-3)',
'Pacific/Pago_Pago (UTC-11)',
'Europe/Vienna (UTC+2)',
'Australia/Lord_Howe (UTC+11)',
'Antarctica/Macquarie (UTC+11)',
'Australia/Hobart (UTC+10)',
'Australia/Currie (UTC+10)',
'Australia/Melbourne (UTC+10)',
'Australia/Sydney (UTC+10)',
'Australia/Broken_Hill (UTC+10)',
'Australia/Brisbane (UTC+10)',
'Australia/Lindeman (UTC+10)',
'Australia/Adelaide (UTC+9:30)',
'Australia/Darwin (UTC+9:30)',
'Australia/Perth (UTC+8)',
'Australia/Eucla (UTC+8:45)',
'Asia/Baku (UTC+4)',
'America/Barbados (UTC-4)',
'Asia/Dhaka (UTC+6)',
'Europe/Brussels (UTC+2)',
'Europe/Sofia (UTC+3)',
'Atlantic/Bermuda (UTC-3)',
'Asia/Brunei (UTC+8)',
'America/La_Paz (UTC-4)',
'America/Noronha (UTC-2)',
'America/Belem (UTC-3)',
'America/Fortaleza (UTC-3)',
'America/Recife (UTC-3)',
'America/Araguaina (UTC-3)',
'America/Maceio (UTC-3)',
'America/Bahia (UTC-3)',
'America/Sao_Paulo (UTC-3)',
'America/Campo_Grande (UTC-4)',
'America/Cuiaba (UTC-4)',
'America/Santarem (UTC-3)',
'America/Porto_Velho (UTC-4)',
'America/Boa_Vista (UTC-4)',
'America/Manaus (UTC-4)',
'America/Eirunepe (UTC-5)',
'America/Rio_Branco (UTC-5)',
'America/Nassau (UTC-4)',
'Asia/Thimphu (UTC+6)',
'Europe/Minsk (UTC+3)',
'America/Belize (UTC-6)',
'America/St_Johns (UTC-2:30)',
'America/Halifax (UTC-3)',
'America/Glace_Bay (UTC-3)',
'America/Moncton (UTC-3)',
'America/Goose_Bay (UTC-3)',
'America/Blanc-Sablon (UTC-4)',
'America/Toronto (UTC-4)',
'America/Nipigon (UTC-4)',
'America/Thunder_Bay (UTC-4)',
'America/Iqaluit (UTC-4)',
'America/Pangnirtung (UTC-4)',
'America/Atikokan (UTC-5)',
'America/Winnipeg (UTC-5)',
'America/Rainy_River (UTC-5)',
'America/Resolute (UTC-5)',
'America/Rankin_Inlet (UTC-5)',
'America/Regina (UTC-6)',
'America/Swift_Current (UTC-6)',
'America/Edmonton (UTC-6)',
'America/Cambridge_Bay (UTC-6)',
'America/Yellowknife (UTC-6)',
'America/Inuvik (UTC-6)',
'America/Creston (UTC-7)',
'America/Dawson_Creek (UTC-7)',
'America/Fort_Nelson (UTC-7)',
'America/Vancouver (UTC-7)',
'America/Whitehorse (UTC-7)',
'America/Dawson (UTC-8)',
'Indian/Cocos (UTC+6:30)',
'Europe/Zurich (UTC+2)',
'Africa/Abidjan (UTC+0)',
'Pacific/Rarotonga (UTC-10)',
'America/Santiago (UTC-4)',
'America/Punta_Arenas (UTC-4)',
'Pacific/Easter (UTC-6)',
'Asia/Shanghai (UTC+8)',
'Asia/Urumqi (UTC+6)',
'America/Bogota (UTC-5)',
'America/Costa_Rica (UTC-6)',
'America/Havana (UTC-4)',
'Atlantic/Cape_Verde (UTC-1)',
'America/Curacao (UTC-4)',
'Indian/Christmas (UTC+7)',
'Asia/Nicosia (UTC+3)',
'Asia/Famagusta (UTC+3)',
'Europe/Prague (UTC+2)',
'Europe/Berlin (UTC+2)',
'Europe/Copenhagen (UTC+2)',
'America/Santo_Domingo (UTC-4)',
'Africa/Algiers (UTC+1)',
'America/Guayaquil (UTC-5)',
'Pacific/Galapagos (UTC-6)',
'Europe/Tallinn (UTC+3)',
'Africa/Cairo (UTC+3)',
'Africa/El_Aaiun (UTC+1)',
'Europe/Madrid (UTC+2)',
'Africa/Ceuta (UTC+2)',
'Atlantic/Canary (UTC+1)',
'Europe/Helsinki (UTC+3)',
'Pacific/Fiji (UTC+12)',
'Atlantic/Stanley (UTC-3)',
'Pacific/Chuuk (UTC+10)',
'Pacific/Pohnpei (UTC+11)',
'Pacific/Kosrae (UTC+11)',
'Atlantic/Faroe (UTC+1)',
'Europe/Paris (UTC+2)',
'Europe/London (UTC+1)',
'Asia/Tbilisi (UTC+4)',
'America/Cayenne (UTC-3)',
'Africa/Accra (UTC+0)',
'Europe/Gibraltar (UTC+2)',
'America/Godthab (UTC-2)',
'America/Danmarkshavn (UTC+0)',
'America/Scoresbysund (UTC+0)',
'America/Thule (UTC-3)',
'Europe/Athens (UTC+3)',
'Atlantic/South_Georgia (UTC-2)',
'America/Guatemala (UTC-6)',
'Pacific/Guam (UTC+10)',
'Africa/Bissau (UTC+0)',
'America/Guyana (UTC-4)',
'Asia/Hong_Kong (UTC+8)',
'America/Tegucigalpa (UTC-6)',
'America/Port-au-Prince (UTC-4)',
'Europe/Budapest (UTC+2)',
'Asia/Jakarta (UTC+7)',
'Asia/Pontianak (UTC+7)',
'Asia/Makassar (UTC+8)',
'Asia/Jayapura (UTC+9)',
'Europe/Dublin (UTC+1)',
'Asia/Jerusalem (UTC+3)',
'Asia/Kolkata (UTC+5:30)',
'Indian/Chagos (UTC+6)',
'Asia/Baghdad (UTC+3)',
'Asia/Tehran (UTC+4:30)',
'Atlantic/Reykjavik (UTC+0)',
'Europe/Rome (UTC+2)',
'America/Jamaica (UTC-5)',
'Asia/Amman (UTC+3)',
'Asia/Tokyo (UTC+9)',
'Africa/Nairobi (UTC+3)',
'Asia/Bishkek (UTC+6)',
'Pacific/Tarawa (UTC+12)',
'Pacific/Enderbury (UTC+13)',
'Pacific/Kiritimati (UTC+14)',
'Asia/Pyongyang (UTC+8:30)',
'Asia/Seoul (UTC+9)',
'Asia/Almaty (UTC+6)',
'Asia/Qyzylorda (UTC+6)',
'Asia/Qostanay (UTC+6)',
'Asia/Aqtobe (UTC+5)',
'Asia/Aqtau (UTC+5)',
'Asia/Atyrau (UTC+5)',
'Asia/Oral (UTC+5)',
'Asia/Beirut (UTC+3)',
'Asia/Colombo (UTC+5:30)',
'Africa/Monrovia (UTC+0)',
'Europe/Vilnius (UTC+3)',
'Europe/Luxembourg (UTC+2)',
'Europe/Riga (UTC+3)',
'Africa/Tripoli (UTC+2)',
'Africa/Casablanca (UTC+1)',
'Europe/Monaco (UTC+2)',
'Europe/Chisinau (UTC+3)',
'Pacific/Majuro (UTC+12)',
'Pacific/Kwajalein (UTC+12)',
'Asia/Yangon (UTC+6:30)',
'Asia/Ulaanbaatar (UTC+8)',
'Asia/Hovd (UTC+8)',
'Asia/Choibalsan (UTC+8)',
'Asia/Macau (UTC+8)',
'America/Martinique (UTC-4)',
'Europe/Malta (UTC+2)',
'Indian/Mauritius (UTC+4)',
'Indian/Maldives (UTC+5)',
'America/Mexico_City (UTC-5)',
'America/Cancun (UTC-5)',
'America/Merida (UTC-5)',
'America/Monterrey (UTC-5)',
'America/Matamoros (UTC-5)',
'America/Mazatlan (UTC-7)',
'America/Chihuahua (UTC-7)',
'America/Ojinaga (UTC-7)',
'America/Hermosillo (UTC-7)',
'America/Tijuana (UTC-7)',
'America/Bahia_Banderas (UTC-6)',
'Asia/Kuala_Lumpur (UTC+8)',
'Asia/Kuching (UTC+8)',
'Africa/Maputo (UTC+2)',
'Africa/Windhoek (UTC+2)',
'Pacific/Noumea (UTC+11)',
'Pacific/Norfolk (UTC+12)',
'Africa/Lagos (UTC+1)',
'America/Managua (UTC-6)',
'Europe/Amsterdam (UTC+2)',
'Europe/Oslo (UTC+2)',
'Asia/Kathmandu (UTC+5:45)',
'Pacific/Nauru (UTC+12)',
'Pacific/Niue (UTC-11)',
'Pacific/Auckland (UTC+12)',
'Pacific/Chatham (UTC+12:45)',
'America/Panama (UTC-5)',
'America/Lima (UTC-5)',
'Pacific/Tahiti (UTC-10)',
'Pacific/Marquesas (UTC-9:30)',
'Pacific/Gambier (UTC-9)',
'Pacific/Port_Moresby (UTC+10)',
'Pacific/Bougainville (UTC+11)',
'Asia/Manila (UTC+8)',
'Asia/Karachi (UTC+5)',
'Europe/Warsaw (UTC+2)',
'America/Miquelon (UTC-2)',
'Pacific/Pitcairn (UTC-8)',
'America/Puerto_Rico (UTC-4)',
'Asia/Gaza (UTC+3)',
'Asia/Hebron (UTC+3)',
'Europe/Lisbon (UTC+1)',
'Atlantic/Madeira (UTC+1)',
'Atlantic/Azores (UTC+0)',
'Pacific/Palau (UTC+9)',
'America/Asuncion (UTC-3)',
'Asia/Qatar (UTC+3)',
'Indian/Reunion (UTC+4)',
'Europe/Bucharest (UTC+3)',
'Europe/Belgrade (UTC+2)',
'Europe/Kaliningrad (UTC+3)',
'Europe/Moscow (UTC+3)',
'Europe/Simferopol (UTC+3)',
'Europe/Kirov (UTC+3)',
'Europe/Astrakhan (UTC+4)',
'Europe/Volgograd (UTC+4)',
'Europe/Saratov (UTC+4)',
'Europe/Ulyanovsk (UTC+4)',
'Europe/Samara (UTC+4)',
'Asia/Yekaterinburg (UTC+5)',
'Asia/Omsk (UTC+6)',
'Asia/Novosibirsk (UTC+7)',
'Asia/Barnaul (UTC+7)',
'Asia/Tomsk (UTC+7)',
'Asia/Novokuznetsk (UTC+7)',
'Asia/Krasnoyarsk (UTC+7)',
'Asia/Irkutsk (UTC+8)',
'Asia/Chita (UTC+9)',
'Asia/Yakutsk (UTC+9)',
'Asia/Khandyga (UTC+9)',
'Asia/Vladivostok (UTC+10)',
'Asia/Ust-Nera (UTC+10)',
'Asia/Magadan (UTC+11)',
'Asia/Sakhalin (UTC+11)',
'Asia/Srednekolymsk (UTC+11)',
'Asia/Kamchatka (UTC+12)',
'Asia/Anadyr (UTC+12)',
'Asia/Riyadh (UTC+3)',
'Pacific/Guadalcanal (UTC+11)',
'Indian/Mahe (UTC+4)',
'Africa/Khartoum (UTC+2)',
'Europe/Stockholm (UTC+2)',
'Asia/Singapore (UTC+8)',
'America/Paramaribo (UTC-3)',
'Africa/Juba (UTC+3)',
'Africa/Sao_Tome (UTC+0)',
'America/El_Salvador (UTC-6)',
'Asia/Damascus (UTC+3)',
'America/Grand_Turk (UTC-4)',
'Africa/Ndjamena (UTC+1)',
'Indian/Kerguelen (UTC+5)',
'Asia/Bangkok (UTC+7)',
'Asia/Dushanbe (UTC+5)',
'Pacific/Fakaofo (UTC+13)',
'Asia/Dili (UTC+9)',
'Asia/Ashgabat (UTC+5)',
'Africa/Tunis (UTC+2)',
'Pacific/Tongatapu (UTC+13)',
'Europe/Istanbul (UTC+3)',
'America/Port_of_Spain (UTC-4)',
'Pacific/Funafuti (UTC+12)',
'Asia/Taipei (UTC+8)',
'Europe/Kiev (UTC+3)',
'Europe/Uzhgorod (UTC+3)',
'Europe/Zaporozhye (UTC+3)',
'Pacific/Wake (UTC+12)',
'America/New_York (UTC-4)',
'America/Detroit (UTC-4)',
'America/Kentucky/Louisville (UTC-4)',
'America/Kentucky/Monticello (UTC-4)',
'America/Indiana/Indianapolis (UTC-4)',
'America/Indiana/Vincennes (UTC-4)',
'America/Indiana/Winamac (UTC-4)',
'America/Indiana/Marengo (UTC-4)',
'America/Indiana/Petersburg (UTC-4)',
'America/Indiana/Vevay (UTC-4)',
'America/Chicago (UTC-5)',
'America/Indiana/Tell_City (UTC-5)',
'America/Indiana/Knox (UTC-5)',
'America/Menominee (UTC-5)',
'America/North_Dakota/Center (UTC-5)',
'America/North_Dakota/New_Salem (UTC-5)',
'America/North_Dakota/Beulah (UTC-5)',
'America/Denver (UTC-6)',
'America/Boise (UTC-6)',
'America/Phoenix (UTC-7)',
'America/Los_Angeles (UTC-7)',
'America/Anchorage (UTC-8)',
'America/Juneau (UTC-8)',
'America/Sitka (UTC-8)',
'America/Metlakatla (UTC-8)',
'America/Yakutat (UTC-8)',
'America/Nome (UTC-8)',
'America/Adak (UTC-9)',
'Pacific/Honolulu (UTC-10)',
'America/Montevideo (UTC-3)',
'Asia/Samarkand (UTC+5)',
'Asia/Tashkent (UTC+5)',
'America/Caracas (UTC-4)',
'Asia/Ho_Chi_Minh (UTC+7)',
'Pacific/Efate (UTC+11)',
'Pacific/Wallis (UTC+12)',
'Pacific/Apia (UTC+13)',
'Africa/Johannesburg (UTC+2)',
]
const date = new Date();

export default function () {
	const data = [];
	aryIanaTimeZones.forEach((timezone, i) => {
		const dateTime = date.toLocaleString('en-US', { timeZone: `${timezone}` });
		data.push({ timezone, dateTime: `${timezone} - ${dateTime}`, detailedTimeZone: TimeZones[i] })
	});
	return data;
}
